import React from 'react'
import PropTypes from 'prop-types'

const PreparationStep = ({ collectId }) => (
  <div>
    <p className="font-weight-bolder mb-2">
      Importez votre questionnaire à l&apos;aide du modèle ci-dessous,
      sans en modifier la structure :
    </p>
    <a
      className="btn btn-light btn-block border"
      href={`/collects/${collectId}/import/template`}
      download
    >
      <i className="fas fa-download mr-2" />
      <span>Télécharger le modèle</span>
    </a>
    <div className="alert alert-info-blue d-flex align-items-center mt-3 mb-0 py-2">
      <i className="fas fa-arrow-right mr-2" />
      <span>
        Remplissez le modèle avec vos sections et questions,
        puis importez le à l&apos;étape suivante.
      </span>
    </div>
    <div className="mt-4">
      <p className="font-weight-bolder mb-2">
        Consignes de remplissage du fichier Excel :
      </p>
      <p className="mb-2">
        Les nouvelles sections et questions ajoutées lors de l&apos;import
        viennent compléter le contenu existant, sans le remplacer.
        L&apos;importation des questions de type « variable » n&apos;est pas
        prise en charge.
      </p>
      <div className="border rounded p-3">
        <p className="mb-2">
          <span className="font-weight-bolder">1. Structure du fichier :</span>
          {' '}
          N&apos;ajoutez aucune colonne ou valeur personnalisée dans les menus déroulants.
        </p>
        <p className="mb-2">
          <span className="font-weight-bolder">2. Nom des colonnes :</span>
          {' '}
          Ne modifiez pas les intitulés des colonnes.
        </p>
        <p className="mb-0">
          <span className="font-weight-bolder">3. Informations requises :</span>
          {' '}
          Aucune cellule ne doit être laissée vide.
        </p>
      </div>
    </div>
  </div>
)

PreparationStep.propTypes = {
  collectId: PropTypes.number.isRequired
}

export default PreparationStep
